import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentToken, setCredentials } from "./authSlice";

const RequireAuth = () => {
  const dispatch = useDispatch();
  let token: any = useSelector(selectCurrentToken);
  const location = useLocation();

  if (!token) {
    const userData = JSON.parse(localStorage.getItem("userData") as string);
    if (userData?.accessToken) {
      dispatch(
        setCredentials({
          ...userData,
        })
      );
      token = userData?.accessToken;
    }
  }

  return token ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
